/* eslint-disable */
import ApiService from '@/services/Base/ApiService';
import communicationService from '@/services/PostMessageCommunation/CommunicationService';
import dataKeys from '@/services/PostMessageCommunation/enums/DataKeys';

const getDefaultState = () => {
  return {
    uiResults: null,

    savedUiDetails: null,

    isOpenedAncientProxDetail: false,
    openedAncientProxDetail: { id: 0, },
    openedAncientProxDetails: {},
  }
}

const state = getDefaultState()

const getters = {
  getUiResults(state) {
    return state.uiResults;
  },
}

const mutations = {
  setUiResults(state, data) {
    state.uiResults = data;
  },
}

const actions = {
  async fetchAncientProxDetails(context, groupedSourceCodes) {
    try {
      if (!groupedSourceCodes) {
        return;
      }
      const saveDetail = context.state.savedUiDetails;
      if (saveDetail) {
        return saveDetail;
      } else {
        const response = await ApiService.get('AncientProxDetail');
        if (response.statusCode === 200) {
          context.state.savedUiDetails = response.result.filter(x => groupedSourceCodes.includes(x.sourceCode));
          return context.state.savedUiDetails;
        } else {
          throw error;
        }
      }
      
    } catch (error) {
      throw error;
    }
  },

  async fetchAncientProxDetail(context, { report, id }) {
    try {
      const response = await ApiService.get(`AncientProxDetail/${id}`);
      if (response.statusCode === 200) {
        context.state.openedAncientProxDetail = response.result;
        return response.result;
      } else {
        throw error;
      }
      
    } catch (error) {
      let savedUiDetails = context.state.savedUiDetails === null ? null : context.state.savedUiDetails.length;
      communicationService.sendDataToParent({
        key: dataKeys.ERROR_HANDLER,
        value: JSON.stringify({ code: '0296', message: `report:${report}, context.state.savedUiDetails: ${savedUiDetails}` }),
      });
      throw error;
    }
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
